import React, { useState, useEffect,useMemo } from "react";
import Logo2 from "../assets/images/navbar/hubblehox-logo.png";
import CetExamLogo from "../assets/images/navbar/cet-exam-logo.jpg"
import { CiLogout } from "react-icons/ci";
import { RiDashboardHorizontalFill } from "react-icons/ri";
import {
  PiExam,
  PiGraduationCap,
  PiHand,
  PiIdentificationCard,
  PiNote,
  PiNotePencilBold,
  PiQuestionBold,
  PiReceipt,
} from "react-icons/pi";
import { useDispatch, useSelector } from "react-redux";
import authActions from "../redux/auth/actions";
import candidatesActions from "../redux/candidates/actions";
import { Box, AppBar, Divider, Tooltip } from "@mui/material";
import Cookies from "js-cookie";
import { useNavigate, useLocation } from "react-router-dom";
import { cssProperties } from "../utils/commonCssProperties";
import { CgPlayTrackPrevR, CgProfile } from "react-icons/cg";
import reg from "../../src/assets/images/sidebar/registration.svg";
import scorecard from "../../src/assets/images/sidebar/score card.svg";
import objection from "../../src/assets/images/sidebar/objection-tracker.svg";
import reghover from "../../src/assets/images/sidebar/registration-active.svg";
import scorecardhover from "../../src/assets/images/sidebar/score card-active.svg";
import objectionhover from "../../src/assets/images/sidebar/objection-tracker-active.svg";
import { PiCreditCardLight } from "react-icons/pi";
import { MdHomeFilled } from "react-icons/md";
import { MdOutlineLogout } from "react-icons/md";
import commonReducer from "../redux/common/reducer";
import objectionTrackActions from "../redux/objectionTracker/actions";
import IconRenderer from "../common/iconRender.js";


function Sidebar() {
  const [hoveredItem, setHoveredItem] = useState(null);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const { pathname, search } = location;
  // console.log(uploadDetails,"upd from sidebar")
  // const candidateid = useSelector(
  //   (state) => state?.authReducer?.ProfileSummaryDetails[0]?.candidateid
  // );
  const menuData =useSelector((state)=>state.authReducer.menuDetails)
  const ProfileSummaryDetails = useSelector(
  (state) => state.authReducer.ProfileSummaryDetails
);
const {
  candidateid,
  candidatename,
  mobilenoverified,
  profiledetailstatus,
  addressdetailstatus,
  otherdetailstatus,
  uploaddetailstatus,
} = ProfileSummaryDetails?.[0] || {};

  const { objectionCourses } = useSelector(
    (state) => state.objectionTrackerReducer
  );


  const paymentReceiptList = useSelector(
        (state) => state.candidatesReducer?.paymentReceiptList
      );

        const isVenueAllocationPage = pathname.includes('/venue-allocation') && 
                               search.includes('courseid=') && 
                               search.includes('coursename=');

      

  const handleLogout = () => {
    dispatch({ type: authActions.CANDIDATE_LOGOUT });
  };

  // useEffect(() => {
  //   dispatch({ type: candidatesActions.GET_UPLOAD_PERSONAL_DETAILS });
  // }, [])

  // useEffect(() => {
  //       if (candidateid && paymentReceiptList?.length == 0) {
  //         dispatch({
  //           type: "GET_PAYMENT_RECEIPT_LIST",
  //           payload: { candidateid: candidateid },
  //         });
  //       }
  //     }, [candidateid, paymentReceiptList?.length]);

    let isMenuOpen = paymentReceiptList?.some((val) => val?.statustext === 'Paid')


  // useEffect(() => {
  //   if (candidateid && objectionCourses?.length == 0) {
  //     dispatch({
  //       type: objectionTrackActions.GET_OBJECTION_COURSES,
  //       payload: { candidateid },
  //     });
  //   }
  // }, [candidateid]);


  // const { personalDetails, uploadDetails, addressDetails, otherDetails } = useSelector((state) => state.candidatesReducer);
  // const { clickable} = useSelector((state) => state.commonReducer);
  const clickable = sessionStorage.getItem('uploaddetails')

  const allProfiledetailsDraft = 
  // personalDetails?.[0]?.candidatedraftid == null
  //   && addressDetails?.[0]?.candidateaddressdraftid == null
  //   && otherDetails?.[0]?.candidateotherdetailsdraftid == null
  //   &&
     uploaddetailstatus?.[0]?.statusmain  ? true : false

 const items = useMemo(() => {
  if (!Array.isArray(menuData)) return [];

  const projectPath = `/${sessionStorage.getItem("mhet_cnd_project")}`;
  // console.log(projectPath,"projectpoathconsoeld")

  return menuData.filter((entry) => entry.is_sidebar_enabled === true).map((entry) => {
    const menuCode = entry.menu_code;
    const basePath = entry.path ? `${projectPath}/${entry.path}` : "";

    let isDisabled = entry.disabled ?? false;
    let finalPath = basePath;

    // Override logic based on business rules
    switch (menuCode) {
      case "HOME":
        // isDisabled = uploaddetailstatus !== 2;
        finalPath = isDisabled ? "" : `${projectPath}/home`;
        break;

      case "PROFILE":
        finalPath = clickable ? `${projectPath}/registration?page=personaldetails` : "";
        break;

      case "CET_REGISTRATION":
        if (clickable) {
          finalPath = `${projectPath}/course-selection`;
        } else {
          isDisabled = true;
          finalPath = "";
        }
        break;

      case "HALL_TICKET":
      case "SCORE_CARD":
      case "OBJECTION_TRACKER":
        isDisabled = !(clickable && isMenuOpen);
        finalPath = isDisabled ? "" : basePath;
        break;

      case "HELP_DESK":
      case "CAP_REGISTRATION":
      case "CET_NOTIFICATION":
      case "CAP_NOTIFICATION":
      case "ARA":
      case "RESPONSE_SHEET":
      case "RAISE_QUERY":
      case "COLLEGE_SELECTION":
        isDisabled = true;
        finalPath = "";
        break;

      default:
        // keep default path if available
        finalPath = basePath;
    }
    if (entry?.is_active === false) {
      isDisabled = true;
      finalPath = "";
    }

    return {
      ...entry,
      path: finalPath,
      disabled: isDisabled,
      icon: (
         <IconRenderer
          index={entry.menu_code}
          iconName={entry.icon}
          named="Sidebar"
          filter=""
          width="25px"
          height="25px"
          isHover={false}
        />
      ),
      hoverIcon: (
         <IconRenderer
          index={entry.menu_code}
          iconName={entry.icon}
          named="Sidebar"
          filter=""
          width="25px"
          height="25px"
          color="white"
          isHover={true}
        />
      ),
    };
  });
}, [menuData, uploaddetailstatus, clickable, isMenuOpen]);


  return (
    <AppBar
      position="fixed"
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        width: "97px",
        height: "100vh",
        left: 0,
        backgroundColor: "#FFFFFF",
        scrollbarWidth: "thin",
        justifyContent: "space-between",
        // padding: "24px 0px 24px 24px",
        boxShadow: "none",
        // padding: "16px",
        paddingTop:"12px",
        paddingLeft:"16px",
        paddingRight:"16px",
        paddingBottom:"16px"
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          // cursor: "pointer",
        }}
        // onClick={() => navigate(`/${sessionStorage.getItem("mhet_cnd_project")}/home`)}
      >
        <img style={{height:50,width:60}} src={CetExamLogo} alt="logo" />
      </Box>
      <Divider style={{ width: "100%" }} />

      <Box
        sx={{
          width:'122%',
          height: "75vh",
          overflowX: "hidden",
          overflowY: "auto",
          scrollbarWidth: "thin",
          "&::-webkit-scrollbar": {
            width: "4px",
          },
          "&::-webkit-scrollbar-thumb": {
            backgroundColor: "rgba(0, 0, 0, 0.2)",
          },
          "@-moz-document url-prefix()": {
            scrollbarWidth: "thin",
          },

        }}
      >
        <Box
          sx={{
            display: "flex",
            width: "110%",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            gap: "12px",
            // margin: "10px 0px",
            paddingRight: "4px",
          }}
        >
          {items.map((item, index) => {
            // console.log(item,"item consoled")
            const isActive =
              pathname === item.path ||
              pathname + search === item.path ||
              (Array.isArray(item.subPath) &&
                item.subPath.some((subPath) =>
                  (pathname + search).includes(subPath)
                ));

            const handleMouseEnter = () => setHoveredItem(item.name);
            const handleMouseLeave = () => setHoveredItem(null);

            return (
              <Tooltip
              title={ (item.name == 'CET Registration' && item.disabled ) ? "Profile to be completed before initiating the CET Application Form Registration" : item.name}
              arrow
              
            >
              
              <Box
                key={index}
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  width: "100%",
                  paddingRight:"5px",
                  // cursor: item.disabled ? "not-allowed" : clickable ?  "pointer": "wait" ,
                  cursor: item.disabled ? "not-allowed" : "pointer",
                  "& .item-icon": {
                    backgroundColor:
                      isActive || hoveredItem === item.name
                        ? `${cssProperties?.hoverbgcolor?.sidebar}`
                        : "inherit",
                    borderRadius: "52px",
                    color:
                      isActive || hoveredItem === item.name
                        ? "#FFFFFF"
                        : `${cssProperties?.color?.textsecondary}`,
                    color:
                      isActive || hoveredItem === item.name
                        ? "#FFFFFF"
                        : `${cssProperties?.color?.textsecondary}`,
                  },
                  "& .item-name": {
                    color:
                      isActive || hoveredItem === item.name
                        ? `${cssProperties?.color?.primary2}`
                        : `${cssProperties?.color?.textsecondary}`,
                  },
                }}
                // onClick={() => (!item.disabled && item.path ? navigate(item.path) : null)}
                  onClick={() => {
                    if (item.disabled) return;
                    if (item.name === "Home") {
                      window.location.href = `${process.env.REACT_APP_KEYCLOAK_REDIRECT_URI}`;
                    } else if (item.path) {
                      navigate(item.path);
                    }
                  }}
                onMouseEnter={handleMouseEnter}
                onMouseLeave={handleMouseLeave}
              >
                <Box
                  className={"item-icon"}
                  sx={{
                    color: "#666666",
                    width: "64px",
                    textAlign: "center",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "38px",
                  }}
                >
                  {hoveredItem === item.name || isActive
                    ? item.hoverIcon
                    : item.icon}
                </Box>
                <Box
                  className={"item-name"}
                  sx={{
                    width:"100%",
                    color: "#666666",
                    fontSize: "12px",
                    textAlign: "center",
                    fontFamily: "Graphik",
                    // cursor: item.disabled ? "not-allowed" : clickable ?  "pointer": "wait" ,
                    cursor: item.disabled ? "not-allowed" : "pointer",
                    marginTop: "6px",
                    whiteSpace: "normal",
                    wordBreak: "break-word",
                    overflow: "visible",
                    lineHeight: "1.2",
                  }}
                >
                  {item.name}
                </Box>

              </Box>
              </Tooltip>
            
            );
          })}
        </Box>
      </Box>
      <Divider style={{ width: "100%" }} />
      <Box
        sx={{
          width: "100%",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          color: "#3F41D1",
          paddingRight: "12px",
        }}
      >
        <Box
          className={"item-icon"}
          sx={{ 
            cursor: "pointer" 
          }}
          onClick={() => handleLogout()}
        >
          <MdOutlineLogout
            style={{
              "&:hover": {
                backgroundColor: "#E1E8F5",
                borderRadius: "10%",
                "& .item-icon, & .item-name": {
                  color: "#0F4F96",
                },
              },
            }}
            size={24}
            color="#666666"
          />
        </Box>
        <Box
          className={"item-name"}
          sx={{
            color: "#0F4F96",
            fontSize: "12px",
            textWrap: "wrap",
            textAlign: "center",
            font: "Graphik",
            cursor: "pointer",
          }}
        >
          {"Logout"}
        </Box>
      </Box>
    </AppBar>
  );
}

export default Sidebar;
